<template>
  <div class="store-tags responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader :pageHeader="listPageHeader" :links="[
        { name: 'home', label: 'Home' },
        { name: 'storeTags', label: 'Store Tags' },
      ]" :entity="entity" :hideAddButton="true">
        <Button label="Sync Tags" iconGroup="fas" iconName="file-export" :colorType="2" @click="syncTags()" :isLoading="stateLoadingStatus.pullTags" />
      </PageHeader>

      <SearchTable :entity="entity" :sort="sort" @sortChangeEvent="updateSort" :filterButtons="filterButtons"
        @filterButtonsChange="updateFilterButtons" :enableAdditionalFilter="true" :pagination="pagination"
        @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter" />
    </div>
  </div>
</template>

  <script>
  import PageHeader from "@/components/PageHeader.vue";
  import { listPageHeader } from "./inputs";
  import SearchTable from "@/components/SearchTable.vue";
  import Button from "@/components/Base/Button/Button.vue";
  import moment from "moment";
  import Entities from "@/resources/Entities";
  import { mapActions, mapGetters } from "vuex";

  export default {
    name: "storeTags",
    data() {
      return {
        moment: moment,
        Entities,
        listPageHeader,
        entity: Entities.STORETAG,
      };
    },
    mounted: function () {
      this.setPageTitle("StoreTags");
    },
    components: {
      PageHeader,
      SearchTable,
      Button,
    },
    computed: {
      ...mapGetters({
        sort: "storeTagModule/sort",
        pagination: "storeTagModule/pagination",
        initialFilter: "storeTagModule/initialFilter",
        filterButtons: "storeTagModule/filterButtons",
        stateLoadingStatus: "stateModule/loadingStatus",
      }),
    },
    methods: {
      ...mapActions({
        updateSort: "storeTagModule/updateSort",
        updatePagination: "storeTagModule/updatePagination",
        updateInitialFilter: "storeTagModule/updateInitialFilter",
        updateFilterButtons: "storeTagModule/updateFilterButtons",
        pullTags: "stateModule/pullTags",
        setMessage: "setMessage",
      }),
      syncTags() {
        const positiveCallback = (response) => {
            const {successCount, failedTags} = response

            if(failedTags?.length > 0) {
              const failedTagsNames = failedTags?.map(m => m.message).join("\n");
              this.setMessage({
                title: "Partial State Sync",
                text: "Synced " + successCount + " tags.\n\nFailed to sync " + failedTags.length + " tags:\n" + failedTagsNames,
                type: "state-error"
              });
              return;
            }

            const text = successCount > 0 ? "Synced " + successCount + " tag(s)!" : "Up to date!";
            this.setMessage({
              isOpen: true,
              text: text,
              type: "success"
            });
        };

        this.pullTags({positiveCallback});
      },
    },
  };
  </script>
